export default function isNum(value) {
  return (typeof value === 'number')
}
